import { useEffect, useState } from 'react'

/**
 * Devuelve el valor `value` con un retardo de `delay` ms.
 * Extraído de Search.jsx para reutilizarlo en el Design System.
 *
 * @template T
 * @param {T} value
 * @param {number} delay
 * @returns {T}
 */
export function useDebounce(value, delay = 400) {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(timer)
  }, [value, delay])
  return debounced
}

export default useDebounce
